/* eslint-disable baseline-js/use-baseline -- touch events drive intentional swipe gestures and are supported by all target browsers */
import React, { type JSX } from "react";

type props = {
	children: JSX.Element;
	swipeLeft: () => void;
	swipeRight: () => void;
};

export const SwipeGesture = ({ children, swipeLeft, swipeRight }: props) => {
	let eventStart: number;

	const onTouchStart = (event: React.TouchEvent) => {
		eventStart = event?.changedTouches[0]?.clientX;
	};

	const onTouchEnd = (event: React.TouchEvent) => {
		const eventeEnd = event?.changedTouches[0]?.clientX;

		if (eventStart < eventeEnd) {
			const diff = eventeEnd - eventStart;
			if (diff > 100) {
				swipeRight();
			}
		} else {
			const diff = eventStart - eventeEnd;
			if (diff > 100) {
				swipeLeft();
			}
		}
	};

	const onTouchCancel = () => {
		eventStart = 0;
	};

	return (
		<div onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onTouchCancel={onTouchCancel}>
			{children}
		</div>
	);
};
